/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";
import Section from "../Section/Section";
import Video from "../Video/Video";

export default function ProductVideos({ product, ...rest }) {
  if (!hasContent(product)) return null;
  const needsTitle = !product.videos[0]?.title;
  return (
    <Section title={needsTitle && <Trans>Videos</Trans>} {...rest}>
      {product.videos.map((video) => (
        <Video key={video?.videoId} {...video} />
      ))}
    </Section>
  );
}
ProductVideos.hasContent = hasContent;
function hasContent(product) {
  if (!product?.videos?.length) return false;
  return product.videos.some((video) => Video.hasContent(video));
}

export const fragment = graphql(`
  fragment bb_ProductVideos on Bottlebooks_Product {
    videos {
      videoId
      ...bb_Video
    }
  }
`);

ProductVideos.fragment = gql`
  fragment ProductVideos on Product {
    videos {
      videoId
      ...Video
    }
  }
  ${Video.fragment}
`;
